import classNames from 'classnames';
import React, { useCallback, useState } from 'react';
import { Modal } from "./components/Modal/Modal.js";
import { Backdrop } from "../backdrop/Backdrop.js";
import { Fab } from "../fab/Fab.js";
import styles from "./FabModal.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function FabModal({
  children,
  floatingButtonIcon,
  modalHeaderImage,
  modalHeaderImageAlt,
  className,
  modalHeaderIcon,
  modalHeaderText,
  onClick
}) {
  const [isOpen, setIsOpen] = useState(false);
  const handleButtonClick = useCallback(() => {
    const value = !isOpen;
    setIsOpen(value);
    onClick?.(value);
  }, [isOpen, onClick]);
  const handleBackdropClick = () => {
    setIsOpen(false);
  };
  return /*#__PURE__*/_jsxs("div", {
    className: classNames(className, styles.fabModal),
    children: [/*#__PURE__*/_jsx(Fab, {
      onClick: handleButtonClick,
      icon: floatingButtonIcon,
      showCloseIcon: isOpen,
      iconSize: 30,
      className: styles.button
    }), /*#__PURE__*/_jsx(Modal, {
      headerImage: modalHeaderImage,
      headerImageAlt: modalHeaderImageAlt,
      isOpen: isOpen,
      headerIcon: modalHeaderIcon,
      headerText: modalHeaderText,
      children: children
    }), /*#__PURE__*/_jsx(Backdrop, {
      onClick: handleBackdropClick,
      open: isOpen
    })]
  });
}
export const FabModalModal = Modal;